import React from 'react';
import InteractiveAvatar from '../components/InteractiveAvatar';

const AvatarDemo = () => {
  const handleSessionEnd = () => {
    console.log('Session ended!');
    alert('Session ended successfully!');
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4">
        <div className="mb-8 text-center">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Interactive Avatar Demo
          </h1>
          <p className="text-gray-600 text-lg">
            New features: video expansion and session termination
          </p>
        </div>

        <div className="bg-white rounded-3xl shadow-xl shadow-black/5 border border-gray-100 p-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">
            Ashley Copley - AI Coaching Companion
          </h2>

          <div className="mb-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
            <h3 className="font-medium text-blue-900 mb-2">New capabilities:</h3>
            <ul className="text-blue-700 text-sm space-y-1">
              <li>🗖 <strong>"Fullscreen" button</strong> - expands video to full screen</li>
              <li>🗗 <strong>"Minimize" button</strong> - returns video to normal size</li>
              <li>✕ <strong>"End Session" button</strong> - appears when conversation starts</li>
              <li>📱 <strong>Smart detection</strong> - automatically detects when user interacts</li>
            </ul>
          </div>

          <InteractiveAvatar
            avatarId="ca655ceed9e24b0eab82950b464c8e17"
            onSessionEnd={handleSessionEnd}
          />
        </div>

        <div className="mt-6 grid md:grid-cols-2 gap-6">
          <div className="bg-white rounded-3xl shadow-xl shadow-black/5 border border-gray-100 p-4 sm:p-6">
            <h3 className="font-semibold text-gray-900 mb-2">How to use fullscreen:</h3>
            <ol className="text-sm text-gray-600 space-y-1">
              <li>1. Wait for avatar to load</li>
              <li>2. Click "🗖 Fullscreen" button</li>
              <li>3. Video will open in full screen</li>
              <li>4. Click "🗗 Minimize" to return to normal size</li>
            </ol>
          </div>

          <div className="bg-white rounded-3xl shadow-xl shadow-black/5 border border-gray-100 p-4 sm:p-6">
            <h3 className="font-semibold text-gray-900 mb-2">Smart End Session:</h3>
            <ol className="text-sm text-gray-600 space-y-1">
              <li>1. Start conversation with avatar</li>
              <li>2. "End Session" button will appear automatically</li>
              <li>3. Click it to restart the avatar session</li>
              <li>4. Button only shows when needed</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AvatarDemo;
